import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContractType } from "../objects/contractType";
import { InsuranceIncentive } from "../objects/insurance-incentive";
import { InsuranceProduct, ProductBrand } from "../objects/insurance-product";
import { InsuranceProductDiscount } from "../objects/insurance-product-discount";
import { InsuranceProductFamily } from "../objects/insurance-product-family";
import { CrudModeOptions, ProductIconState, ProductState } from "../objects/productState";

const initialState: ProductState = {
    selected_family: null,
    family_list: [],
    selected_extension: null,
    extension_list: [],
    selected_product: null,
    product_list: [],
    selected_discount: null,
    discount_list: [],
    selected_incentive: null,
    incentive_list: [],
    all_incentive_list: [],
    icon_state: null,
    product_mode: null,
    family_mode: null,
    extension_mode: null,
    discount_mode: null,
    incentive_mode: null,
    product_search: null,
    product_family_search: null,
    product_discount_search: null,
    all_incentive_search: null,
    contract_types: null,
    brands: null,
};

export const product = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setSelectedFamily: (state: ProductState, action: PayloadAction<InsuranceProductFamily | null>): ProductState => ({
            ...state, selected_family: action.payload
        }),
        setFamilyList: (state: ProductState, action: PayloadAction<InsuranceProductFamily[]>): ProductState => ({
            ...state, family_list: action.payload
        }),
        setSelectedExtension: (state: ProductState, action: PayloadAction<InsuranceProduct | null>): ProductState => ({
            ...state, selected_extension: action.payload
        }),
        setExtensionList: (state: ProductState, action: PayloadAction<InsuranceProduct[]>): ProductState => ({
            ...state, extension_list: action.payload
        }),
        setSelectedProduct: (state: ProductState, action: PayloadAction<InsuranceProduct | null>): ProductState => ({
            ...state, selected_product: action.payload
        }),
        setProductList: (state: ProductState, action: PayloadAction<InsuranceProduct[]>): ProductState => ({
            ...state, product_list: action.payload
        }),
        setSelectedDiscount: (state: ProductState, action: PayloadAction<InsuranceProductDiscount | null>): ProductState => ({
            ...state, selected_discount: action.payload
        }),
        setDiscountList: (state: ProductState, action: PayloadAction<InsuranceProductDiscount[]>): ProductState => ({
            ...state, discount_list: action.payload
        }),
        setSelectedIncentive: (state: ProductState, action: PayloadAction<InsuranceIncentive | null>): ProductState => ({
            ...state, selected_incentive: action.payload
        }),
        setIncentiveList: (state: ProductState, action: PayloadAction<InsuranceIncentive[]>): ProductState => ({
            ...state, incentive_list: action.payload
        }),
        setAllIncentiveList: (state: ProductState, action: PayloadAction<InsuranceIncentive[]>): ProductState => ({
            ...state, all_incentive_list: action.payload
        }),
        setIconState: (state: ProductState, action: PayloadAction<ProductIconState | null>): ProductState => ({
            ...state, icon_state: action.payload
        }),
        setProductMode: (state: ProductState, action: PayloadAction<CrudModeOptions>): ProductState => ({
            ...state, product_mode: action.payload
        }),
        setFamilyMode: (state: ProductState, action: PayloadAction<CrudModeOptions>): ProductState => ({
            ...state, family_mode: action.payload
        }),
        setExtensionMode: (state: ProductState, action: PayloadAction<CrudModeOptions>): ProductState => ({
            ...state, extension_mode: action.payload
        }),
        setDiscountMode: (state: ProductState, action: PayloadAction<CrudModeOptions>): ProductState => ({
            ...state, discount_mode: action.payload
        }),
        setIncentiveMode: (state: ProductState, action: PayloadAction<CrudModeOptions>): ProductState => ({
            ...state, incentive_mode: action.payload
        }),
        setProductSearch: (state: ProductState, action: PayloadAction<string | null>): ProductState => ({
            ...state, product_search: action.payload
        }),
        setAllIncentiveSearch: (state: ProductState, action: PayloadAction<string | null>): ProductState => ({
            ...state, all_incentive_search: action.payload
        }),
        setProductFamilySearch: (state: ProductState, action: PayloadAction<string | null>): ProductState => ({
            ...state, product_family_search: action.payload
        }),
        setProductDiscountSearch: (state: ProductState, action: PayloadAction<string | null>): ProductState => ({
            ...state, product_discount_search: action.payload
        }),
        setContractTypes: (state: ProductState, action: PayloadAction<ContractType[] | null>): ProductState => ({
            ...state, contract_types: action.payload
        }),
        setBrands: (state: ProductState, action: PayloadAction<ProductBrand[] | null>): ProductState => ({
            ...state, brands: action.payload
        }),
    }
});

export const {
    setSelectedFamily,
    setIconState,
    setSelectedExtension,
    setSelectedProduct,
    setSelectedDiscount,
    setSelectedIncentive,
    setProductMode,
    setFamilyMode,
    setExtensionMode,
    setDiscountMode,
    setIncentiveMode,
    setProductSearch,
    setProductDiscountSearch,
    setProductFamilySearch,
    setContractTypes,
    setDiscountList,
    setExtensionList,
    setFamilyList,
    setAllIncentiveSearch,
    setIncentiveList,
    setProductList,
    setAllIncentiveList,
    setBrands
} = product.actions;